import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { Observable } from "rxjs";
import { GlobalService } from "src/app/services/global/global.service";
import { AppUtil } from "../../../utils/app.util";
import { HeaderImageType } from "src/app/constants/header-image-type.constants";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
@Component({
	selector: "app-county-landing",
	templateUrl: "./county-landing.component.html",
	styleUrls: ["./county-landing.component.css"]
})
export class CountyLandingComponent implements OnInit {
	constructor(
		private router: Router,
		public dmvStoreService: DMVStoreService,
		public globalService: GlobalService,
		public megStoreService: MEGStoreService,
		private cd: ChangeDetectorRef
	) {}
	public errorMessage: string;
	public isloading: boolean = false;
	public hasTagCatalogData: boolean = false;
	ngOnInit() {
		// this.dmvStoreService.findAgencyConfigById(
		// 	this.dmvStoreService.selectedAgencyId
		// );
		AppUtil.log("CountyLandingComponent == > ngOnInit()");
		this.dmvStoreService.isPaymentSuccess = false;
		this.errorMessage = null;
		this.globalService.updateHeaderImageType(HeaderImageType.DEFAULT);
		// if (
		// 	this.globalService.isAnnouncementFlow &&
		// 	this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
		// ) {
		// 	this.globalService.isAnnouncementFlow = false;
		// 	this.globalService.isAnnouncementVisible = true;
		// }
		this.dmvStoreService.tagCatalogData$.subscribe(tagCatalogResponse => {
			if (tagCatalogResponse) {
				this.isloading = false;

				if (
					tagCatalogResponse["status"] &&
					tagCatalogResponse["status"] !== 200
				) {
					this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
					this.globalService.setQrCall(false);
					this.globalService.setDirectURLCall(false);
					window.scrollTo(0, 0);
				} else {
					this.hasTagCatalogData = true;
					if (window["qrDetail"] && this.globalService.getQrCall()) {
						if (
							window["qrDetail"].productTypeID === 1 ||
							window["qrDetail"].productTypeID === "1"
						) {
							this.dmvRenewal();
						} else {
							this.errorMessage = this.megStoreService.configuration.megConfig.qrCodeErrorText;
							this.globalService.setQrCall(false);
						}
					} else if (
						this.globalService.params &&
						this.globalService.params.productTypeID &&
						this.globalService.getDirectURLCall()
					) {
						if (window["entryPointParams"]) {
							this.globalService.params = window["entryPointParams"];
							this.globalService.setDirectURLCall(true);
							if (
								!this.dmvStoreService.agencyConfig.agencyDmvConfig
									.homogeneousCart
							) {
								this.globalService.cartNature = "TBD";
							} else {
								this.globalService.cartNature =
									this.globalService.params.deliveryMethodID === "2"
										? "search"
										: "TBD";
							}
						}
						if (
							this.globalService.params.productTypeID === 1 ||
							this.globalService.params.productTypeID === "1"
						) {
							this.dmvRenewal();
						} else {
							this.globalService.setDirectURLCall(false);
						}
					} else if (
						window["externallink"] &&
						this.globalService.getDirectURLCall()
					) {
						this.dmvRenewal();
					}
				}
				this.cd.markForCheck();
			}
		});

		if (!this.hasTagCatalogData) {
			this.isloading = true;
			this.dmvStoreService.findTagCatalog();
		}
	}

	public dmvRenewal() {
		AppUtil.log("CountyLandingComponent == > dmvRenewal()");
		this.globalService.updateHeaderImageType(HeaderImageType.DMV);
		// if (
		// 	this.globalService.isAnnouncementFlow &&
		// 	this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
		// ) {
		// 	this.globalService.isAnnouncementFlow = false;
		// 	this.router.navigate(["app-announcement"], { skipLocationChange: true });
		// } else {
		this.router.navigate(["dmv-search"], { skipLocationChange: true });
		// }
	}
	public back() {
		const message = {
			action: "goToHome"
		};
		window.postMessage(message, "*");
	}
}
